import { PageLayout } from '@/layouts/PageLayout'
import Yoda404 from '@/components/Yoda404'

const NotFound = () => {
  return (
    <PageLayout>
      <Yoda404 />
    </PageLayout>
  )
}

export default NotFound
